import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Container = Box.withConfig({
  backgroundColor: Styles.color.primary,
  padding: '$4',
  marginY: '$4',
});

export const TextBase = Text.withConfig({
  color: primitive.$white,
});

export const Header = TextBase.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: primitive.$white,
});

export const Title = TextBase.withConfig({
  marginLeft: '$1',
  marginY: '$2',
  textTransform: 'uppercase',
});

export const TitleContainer = Box.withConfig({
  alignItems: 'center',
  flexDirection: 'row',
});

export const LineItem = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const TextDetails = TextBase.withConfig({
  variant: 'copyOne',
});
